export default __webpack_public_path__ + "static/media/metamask.b518acdd.svg";